import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

export enum ErrorSeverity {
    Info = 'info',
    Warning = 'warning',
    Error = 'error',
    Critical = 'critical',
}

@Component({
    selector: 'informational-dialog',
    templateUrl: './informational-dialog.component.html',
    styleUrls: ['./informational-dialog.component.scss'],
})
export class InformationalDialogComponent implements OnInit {
    public title: string = '';

    public body: string;

    public hideIcon = false;

    public actionButtonText: string;

    constructor(
        public dialogRef: MatDialogRef<InformationalDialogComponent>,
        public translate: TranslateService,
        @Inject(MAT_DIALOG_DATA)
        public data: {
            title?: string;
            body?: string;
            errorSeverity?: ErrorSeverity;
            hideIcon?: boolean;
            actionButtonText?: string;
        },
    ) {}

    ngOnInit(): void {
        this.title = this.data.title;
        this.body = this.data.body;
        this.hideIcon = this.data.hideIcon || false;
        this.actionButtonText = this.data.actionButtonText;
    }

    getIconClass() {
        switch (this.data.errorSeverity) {
            case ErrorSeverity.Info:
                return 'icon-warning info';
            case ErrorSeverity.Warning:
                return 'icon-warning warning';
            case ErrorSeverity.Error:
                return 'icon-warning error';
            case ErrorSeverity.Critical:
                return 'icon-warning critical';
            default:
                return 'icon-check-circle success'; //is success
        }
    }

    close(): void {
        this.dialogRef.close();
    }
}
